export interface GatewayHealthState {
    online: boolean;
    lastChecked: number;
    failureCount: number;
    pollingInterval: number;
}

let state: GatewayHealthState = {
    online: false,
    lastChecked: 0,
    failureCount: 0,
    pollingInterval: 10000
};

export const healthStateStore = {
    getState: (): GatewayHealthState => {
        return { ...state };
    },
    updateState: (updates: Partial<GatewayHealthState>) => {
        state = { ...state, ...updates };
    }
};